var map = {
	"./logo-chat-sm.svg": 5757,
	"./promo.svg": 26033,
	"./site-logo-desktop-footer.svg": 77584,
	"./site-logo-drawer-mobile.svg": 68778,
	"./site-logo-drawer.svg": 37067,
	"./site-logo-tv.svg": 7438,
	"./site-logo-wrapper-mobile-scrolled.svg": 57365,
	"./site-logo-wrapper-mobile.svg": 13408,
	"./site-logo-wrapper-scrolled.svg": 55786,
	"./site-logo-wrapper.svg": 14917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11505;